// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"151":"f4bbdef7","585":"4b1f2534","958":"2b672ac3"}[chunkId] + ".chunk.js");